export default __webpack_public_path__ + "static/contact-min-93d83adee7cf1e52c233611ac3ee2cad.jpeg";